export default function FacilityCheckboxCheckedIcon({
  width = 12,
  height = 12,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width='12' height='12' rx='1.5' fill='#1283DA' />
      <path
        d='M8.55421 3.54265L4.88329 7.21357L3.54571 5.87599C3.43569 5.76973 3.28834 5.71093 3.13539 5.71226C2.98245 5.71359 2.83614 5.77494 2.72798 5.88309C2.61983 5.99125 2.55848 6.13756 2.55715 6.2905C2.55582 6.44345 2.61462 6.5908 2.72088 6.70082L4.47088 8.45082C4.58027 8.56018 4.72862 8.62161 4.88329 8.62161C5.03797 8.62161 5.18632 8.56018 5.29571 8.45082L9.37904 4.36749C9.4853 4.25747 9.5441 4.11012 9.54277 3.95717C9.54144 3.80422 9.48009 3.65792 9.37194 3.54976C9.26378 3.44161 9.11748 3.38026 8.96453 3.37893C8.81158 3.3776 8.66423 3.4364 8.55421 3.54265Z'
        fill='white'
      />
    </svg>
  );
}
